import { AppHttpClient } from '../../core/http/app-http-client.service';
import * as i0 from "@angular/core";
import * as i1 from "../../core/http/app-http-client.service";
var Subscriptions = /** @class */ (function () {
    /**
     * Subscriptions constructor.
     */
    function Subscriptions(http) {
        this.http = http;
    }
    /**
     * Get all available subscriptions.
     */
    Subscriptions.prototype.all = function (params) {
        return this.http.get('billing/subscriptions', params);
    };
    /**
     * Get subscription matching specified id.
     */
    Subscriptions.prototype.get = function (id) {
        return this.http.get('billing/subscriptions/' + id);
    };
    /**
     * Create a new subscription on stripe.
     */
    Subscriptions.prototype.createOnStripe = function (params) {
        return this.http.post('billing/subscriptions/stripe', params);
    };
    /**
     * Update subscription matching specified id.
     */
    Subscriptions.prototype.update = function (id, params) {
        return this.http.put('billing/subscriptions/' + id, params);
    };
    /**
     * Create a new subscription.
     */
    Subscriptions.prototype.create = function (params) {
        return this.http.post('billing/subscriptions', params);
    };
    /**
     * Cancel subscription matching specified id.
     */
    Subscriptions.prototype.cancel = function (id, params) {
        return this.http.delete('billing/subscriptions/' + id, params);
    };
    Subscriptions.prototype.resume = function (id) {
        return this.http.post('billing/subscriptions/' + id + '/resume');
    };
    Subscriptions.prototype.changePlan = function (id, plan) {
        return this.http.post('billing/subscriptions/' + id + '/change-plan', { newPlanId: plan.id });
    };
    Subscriptions.prototype.addCard = function (token) {
        return this.http.post('billing/stripe/cards/add', { token: token });
    };
    Subscriptions.ngInjectableDef = i0.defineInjectable({ factory: function Subscriptions_Factory() { return new Subscriptions(i0.inject(i1.AppHttpClient)); }, token: Subscriptions, providedIn: "root" });
    return Subscriptions;
}());
export { Subscriptions };
